<template>
  <div class="screen" id="preview">
    <!-- 使用topology组件 -->

    <div class="tools" id="btntool">
      <a-button @click="onFullscreen" type="primary" v-if="fullflag ? false : true">
        <a-icon type="fullscreen" />
      </a-button>
      <a-button @click="onFullscreenExit" type="primary" v-if="fullflag ? true : false">
        <a-icon type="fullscreen-exit" />
      </a-button>
    </div>

    <topology :data="data" :materials="materials" @event="onEvent" preview="true" />

    <points-line-chart-modal
      :getContainer="
        () => {
          return modalEle
        }
      "
      ref="pointsDataLineModal"
    ></points-line-chart-modal>
    <alert-modal ref="alertModal"></alert-modal>
    <a-modal v-model:visible="spinning" :maskClosable="maskClosable" :closable="maskClosable" centered :footer="null">
      <a-spin tip="Loading..."> </a-spin>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import topology from 'topology-vue'
import 'topology-vue/topology-vue.css'
import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
import AlertModal from '@/components/AlertModal'
import { postAction } from '@/api/manage'
import moment from 'dayjs'
import { getTopoGraph } from '@/api/gis'

Vue.use(topology)
import { defalutMenus, defalutMaterialTabs, defalutMaterials } from './data'
export default {
  name: 'preview',
  components: {
    PointsLineChartModal,
    AlertModal
  },
  data() {
    return {
      data: {
        //locked:NoMove
      },
      materials: {
        system: defalutMaterials
      },
      scale: 100,
      fullflag: false,
      topology: null,
      spinning: false,
      maskClosable: false,
      currentJumpId: '',
      url: {
        snapShot: '/monitor/data/getSnapShot'
      }
    }
  },
  computed: {
    modalEle() {
      return document.getElementById('preview')
    }
  },
  watch: {
    $route: {
      handler(newvalue, oldvalue) {
        if (newvalue.name == 'topology-preview') {
          if (newvalue.params && oldvalue.params && newvalue.params.id != oldvalue.params.id) {
            this.setData()
          }
        } else if (newvalue.name == 'topo-monitor') {
          this.setData()
        }
      }
    },
    deep: true
  },
  created() {
    var self = this
    self.setData()
    document.addEventListener('fullscreenchange', (evt1, evt2) => {
      Vue.nextTick(function() {
        window.topology.fitView(0)
      })
    })
  },
  updated() {},
  mounted() {
    Vue.nextTick(function() {
      window.topology.resize()
      window.topology.fitView(0)
    })
    let self = this
    if (!self.topology) {
      window.topology.preview = true
      self.topology = window.topology
    }
    if (self.topology) {
      window.websocket = function(e, echartsObjs) {
        if (!self.topology.preview) {
          return
        }
        var socketdata = JSON.parse(e)
        if (socketdata.payload) {
          self.refreshData(socketdata.payload)
        }
      }
      self.topology.goToJump = function(e) {
        if (e.jumpid && e.jumpid != -1) {
          //self.spinning=true;
          getTopoGraph(e.jumpid).then(res => {
            //self.spinning=false;
            if (res.success) {
              let result = res.result
              let gjson = JSON.parse(result.topoData)
              self.data = gjson
              self.data.socketEvent = true
              self.data.locked = 11
              self.onRender()
              self.currentJumpId = e.jumpid
              self.$emit('topoJump', result)
            }
          })
        }
      }
      self.topology.showLine = function(e) {
        if (e.pen) {
          let pen = e.pen
          if (pen.tags && pen.tags.length > 0) {
            const timeRange = [
              moment()
                .add(-1, 'hours')
                .format('YYYY-MM-DD HH:mm'),
              moment()
                .add(1, 'hours')
                .format('YYYY-MM-DD HH:mm')
            ]
            const pointCode = pen.tags[0]
            self.$refs.pointsDataLineModal.show(pointCode, timeRange)
          } else {
            self.$message.warning('未绑定测点！')
          }
        }
      }
      self.topology.showDevInfo = function(e) {
        console.log('showDevInfo')
        if (e.pen) {
          let pen = e.pen
          if (pen.devcode) {
            self.$bus.$emit('to-page-detail', {
              name: 'FusionDevice',
              id: pen.devcode,
              type: 'drawer'
            })
          } else {
            self.$message.warning('未绑定设备！')
          }
        }
      }
      //显示告警列表
      self.topology.showAlert = function(e) {
        const processId = self.currentJumpId || self.$route.query.processId
        const params = {
          isRecoverry: 0,
          processId
        }
        self.$refs.alertModal.show(null, params)
      }
    }
  },
  methods: {
    setData() {
      var self = this
      if (self.topology) {
        window.topology = self.topology
        window.topology.preview = true
      }
      if (self.$route.params && self.$route.params.id) {
        //带参数
        if (self.$route.params.id == 'preview') {
          if (sessionStorage.getItem('topologyData')) {
            //绘制时预览
            var topologyData = sessionStorage.getItem('topologyData')
            if (topologyData) {
              self.data = JSON.parse(topologyData)
              self.data.socketEvent = true
              self.data.locked = 11
              self.onRender()
            }
          }
        } else {
          getTopoGraph(self.$route.params.id).then(res => {
            if (res.success) {
              let result = res.result
              let gjson = JSON.parse(result.topoData)
              self.data = gjson
              self.data.socketEvent = true
              self.data.locked = 11
              self.onRender()
            }
          })
        }
      } else {
        //不带参数的话，直接进组态主页面
        if (self.currentJumpId) {
          getTopoGraph(self.currentJumpId).then(res => {
            //self.spinning=false;
            if (res.success) {
              let result = res.result
              let gjson = JSON.parse(result.topoData)
              self.data = gjson
              self.data.socketEvent = true
              self.data.locked = 11
              self.onRender()
            }
          })
        } else {
          getTopoGraph().then(res => {
            if (res.success) {
              let result = res.result
              let gjson = JSON.parse(result.topoData)
              self.data = gjson
              self.data.socketEvent = true
              self.data.locked = 11
              self.onRender()
            }
          })
        }
      }
    },
    onSizeWindow() {
      window.topology.fitView(16)
    },

    onSizeOri() {
      this.onScale(0)
    },

    onRender() {
      var self = this
      Vue.nextTick(function() {
        if (window.topology) {
          window.topology.resize()
          window.topology.fitView(0)
          self.initPointData()
        }
      })
    },
    initPointData() {
      const points = []
      this.data.pens.forEach(pen => {
        points.push(...pen.tags)
      })
      if (!points.length) {
        return
      }
      const self = this
      postAction(this.url.snapShot, points).then(res => {
        if (res.success) {
          const snapShot = res.result
          const msg = []
          for (const p of Object.values(snapShot)) {
            msg.push({
              tag: p.pointCode,
              value: p.value,
              time: p.time
            })
          }
          //调用本页面定义的的websocket事件方法
          self.refreshData(msg)
          //调用topology自身的websocket事件方法
          self.topology.doSocket(JSON.stringify({ payload: msg }))
        }
      })
    },
    onFullscreen() {
      this.requestFullscreen()
      this.fullflag = true
    },
    onFullscreenExit() {
      let el = document
      if (el.exitFullscreen) {
        el.exitFullscreen()
      } else if (el.mozCancelFullScreen) {
        el.mozCancelFullScreen()
      } else if (el.webkitCancelFullScreen) {
        el.webkitCancelFullScreen()
      } else if (el.msExitFullscreen) {
        el.msExitFullscreen()
      }
      this.fullflag = false
    },
    requestFullscreen() {
      let element = document.getElementById('preview')
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    onScale(val) {
      if (val === -10) {
        if (this.scale > 30) {
          this.scale += val
        }
      } else if (val === 10) {
        if (this.scale < 500) {
          this.scale += val
        }
      } else {
        this.scale = 100
      }
      window.topology.scaleTo(this.scale / 100)
    },
    onEvent(e) {
      var self = this
      switch (e.name) {
        case 'showLine':
          if (e.params && e.params.pen) {
            let pen = e.params.pen
            if (pen.tags && pen.tags.length > 0) {
              const timeRange = [
                moment()
                  .add(-1, 'hours')
                  .format('YYYY-MM-DD HH:mm'),
                moment()
                  .add(1, 'hours')
                  .format('YYYY-MM-DD HH:mm')
              ]
              const pointCode = pen.tags[0]
              this.$refs.pointsDataLineModal.show(pointCode, timeRange)
            } else {
              this.$message.warning('未绑定测点！')
            }
          }
          break
      }
    },
    refreshData(data) {
      const self = this
      //根据测点数据类型不同，保留不同小数位数
      const dataTypeFixed = {
        float32: 2,
        BOOL: 0,
        int: 0
      }
      data.forEach(function(item) {
        var pens = self.topology.find(item.tag)
        if (pens && pens.length) {
          pens.forEach(function(pen) {
            if (pen.name == 'echarts') {
              let opx = []
              let opdata = []
              if (Array.isArray(pen.data.echarts.option.xAxis)) {
                opx = pen.data.echarts.option.xAxis[0].data
              } else {
                opx = pen.data.echarts.option.xAxis.data
              }
              opdata = pen.data.echarts.option.series[0].data
              if (opdata.length > 10) {
                opdata.shift()
                opx.shift()
              }
              opx.push(item.time.split(' ')[1])
              opdata.push(item.value)
              echartsObjs[pen.id].chart.setOption({
                xAxis: {
                  data: opx
                },
                series: [
                  {
                    data: opdata
                  }
                ]
              })
            } else if (pen.name == 'combine') {
              for (let index = 0; index < pen.children.length; index++) {
                const singleNode = pen.children[index]
                if (singleNode.name.toLowerCase().indexOf('rect') > -1) {
                  singleNode.text = item.value
                }
              }
            } else {
              const fixed = dataTypeFixed[pen.dataType] || 2
              pen.text = parseFloat(item.value).toFixed(fixed)
            }
          })
        } else if (pens) {
          const fixed = dataTypeFixed[pen.dataType] || 2
          pen.text = parseFloat(item.value).toFixed(fixed)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tools {
  position: absolute;
  z-index: 100;
  right: 5px;
  button {
    margin: 12px 16px;
  }
}
.screen {
  height: 100%;
}
.fullScreen {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 19;
}
.fullScreen-tools {
  position: absolute;
  top: 0px;
  z-index: 100;
  width: 100%;
  display: flex;
  button {
    margin: 12px 16px;
  }
}
</style>
